import { render, staticRenderFns } from "./CommerceInternal.vue?vue&type=template&id=667b809c&scoped=true"
import script from "./CommerceInternal.vue?vue&type=script&lang=js"
export * from "./CommerceInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667b809c",
  null
  
)

export default component.exports